import * as Yup from "yup";

export const addUserBankSchema = Yup.object({
    account_number: Yup.string().required("account number is required"),
    bank_name: Yup.string().required("bank name is required"),
    actual_name: Yup.string().required("name is required"),
    ifsc_code: Yup.string().required("IFSC code is required"),
    upi_id: Yup.string().required("UPI is required"),
});
